import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ErrorHandler } from '../interfaces/error-handler';
import { saveAs } from 'file-saver';
import { I18nService } from './i18n.service';

@Injectable({
  providedIn: 'root',
})
export class FileService {

  http = inject(HttpClient);
  i18n = inject(I18nService);

  errorHandler: ErrorHandler;
  success = new Subject<boolean>();

  downloadFile(downloadUrl: string, save: boolean = true): Observable<boolean> {
    this.errorHandler = { hasError: false };
    let headers = new HttpHeaders().set('content-type', 'application/json; charset=utf-8');
    this.http.get(downloadUrl, {headers, responseType: 'blob', observe: 'response'}).subscribe({
      next: response => {
        this.success.next(this.saveToDisk(response));
      },
      error: err => {
        this.errorHandler.hasError = true;
        this.errorHandler.message = this.i18n.i18nLng()['HTTPDATAERROR'];
        this.errorHandler.details = this.i18n.i18nLng()['FILEDOWNLOADERROR'];
        this.success.next(false);
      }
    })
    return this.success.asObservable();
  }

  /**
   * prepare file and save to disk
   * @param response
   * @private
   */
  private saveToDisk(response: any): boolean {
    try {
      const contentDispositionHeader: string = response.headers.get('content-disposition');
      const parts: string[] = contentDispositionHeader.split(';');
      const filename: string = parts[1].split('=')[1].replace(/^"(.*)"$/, '$1');
      const fileBlob = response.body.slice(0);
      const blob = new Blob([fileBlob]);
      saveAs(blob, filename);
      return true;
    } catch (e) {
      this.errorHandler.hasError = true;
      this.errorHandler.message = this.i18n.i18nLng()['HTTPDATAERROR'];
      this.errorHandler.details = this.i18n.i18nLng()['FILESAVEERROR'];
      return false;
    }
  }
}
